import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer id="footer">
    <h2>
      Made by <Link to="/creators">Wadah & Vlad</Link>
    </h2>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/frontend/footer/footer.jsx